//exports.baseURL = 'http://localhost:3600/';
//exports.baseURL = 'https://apitedel.elitebordergroup.com/';
exports.baseURL = 'https://apitransferty.ebtapps.com/';